import auth from './auth'
import notifications from './notifications'

export default {
  auth,
  notifications
}
